<template>
  <FlexMaker :justifyB="true" class="my-4">
    <p class="font-quietSans text-grey600">
      {{ startItem }} -
      {{ endItem }}
      of {{ totalData }}
    </p>
    <FlexMaker :justifyB="true" class="items-center">
      <span 
        @click="handlePrevPage" 
        class="cursor-pointer p-1 rounded hover:bg-gray-100"
        :class="{ 'opacity-50 cursor-not-allowed': currentPage === 1 }"
      >
        <img src="@/assets/svg/arrowtinyLeft.svg" />
      </span>
      <div class="mx-3 font-quietSans text-grey600">
        {{ currentPage }} of {{ totalPages }}
      </div>
      <span 
        @click="handleNextPage" 
        class="cursor-pointer p-1 rounded hover:bg-gray-100"
        :class="{ 'opacity-50 cursor-not-allowed': currentPage === totalPages }"
      >
        <img src="@/assets/svg/arrow-right.svg" />
      </span>
      <select class="ml-5 border border-gray-300 rounded px-2 py-1" :value="pageLimit" @change="handleResetPage">
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
        <option value="500">500</option>
      </select>
    </FlexMaker>
  </FlexMaker>
</template>

<script>
import FlexMaker from "@/components/UI/Wrappers/FlexWrapper.vue";
import Text from "@/components/UI/Text/Text.vue";
export default {
  props: ["paginationData", "handler"],
  components: {
    FlexMaker,
    Text,
  },
  data() {
    return {
      totalData: this.paginationData?.totalData ?? 0,
      pageLimit: this.paginationData?.pageLimit ?? 10,
      currentPage: this.paginationData?.currentPage ?? 1,
      totalPages: this.paginationData?.totalPages ?? 1,
      currentPageData: this.paginationData?.currentPageData ?? 0,
    };
  },

  computed: {
    startItem() {
      if (this.totalData === 0) return 0;
      return ((this.currentPage - 1) * this.pageLimit) + 1;
    },
    endItem() {
      const end = this.currentPage * this.pageLimit;
      return end > this.totalData ? this.totalData : end;
    },
  },

  watch: {
    paginationData: {
      handler(newVal) {
        if (newVal) {
          this.totalData = newVal.totalData ?? 0;
          this.pageLimit = newVal.pageLimit ?? 10;
          this.currentPage = newVal.currentPage ?? 1;
          this.totalPages = newVal.totalPages ?? 1;
          this.currentPageData = newVal.currentPageData ?? 0;
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    handleNextPage() {
      if (this.currentPage >= this.totalPages) {
        return;
      }
      this.handler("", { newPage: +this.currentPage + 1 });
    },
    handlePrevPage() {
      if (+this.currentPage <= 1) {
        return;
      }
      this.handler("", { newPage: +this.currentPage - 1 });
    },
    handleResetPage(e) {
      const chosenLimit = +e.target.value;
      this.handler("reset", { newLimit: chosenLimit });
    },
  },
};
</script>

<style></style>
